var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51519 10.6088L10.8185 5.30546C11.8924 4.23151 13.6336 4.23151 14.7076 5.30546C15.7815 6.3794 15.7815 8.1206 14.7076 9.19454L8.34362 15.5585C7.85546 16.0467 7.06401 16.0467 6.57585 15.5585C6.0877 15.0703 6.0877 14.2789 6.57585 13.7907L12.2327 8.13388C12.5256 7.84099 12.5256 7.36612 12.2327 7.07322C11.9398 6.78033 11.4649 6.78033 11.172 7.07322L5.51519 12.7301C4.44125 13.804 4.44125 15.5452 5.51519 16.6192C6.58914 17.6931 8.33034 17.6931 9.40428 16.6192L15.7682 10.2552C17.428 8.59548 17.428 5.90452 15.7682 4.2448C14.1085 2.58507 11.4176 2.58507 9.75783 4.2448L4.45453 9.5481C4.16164 9.84099 4.16164 10.3159 4.45453 10.6088C4.74743 10.9017 5.2223 10.9017 5.51519 10.6088Z",
    fill: "#3162AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.64d2cdd701f0be18e4f57fa0d0fd220a.svg";
export { ForwardRef as ReactComponent };